// components/Settings/index.js

import Settings from './Settings';

export default Settings;
